
import React from 'react';
import { PropTypes } from 'prop-types';

import { hasAccess } from '../../utils/access';

const SecureComponent = ({ roles, hasPermission, children }) => (hasAccess(roles) || hasPermission ? children : <React.Fragment />);

SecureComponent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  roles: PropTypes.arrayOf(PropTypes.string),
  hasPermission: PropTypes.bool,
};

export default SecureComponent;
